import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, lockedPath } from "@/context/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";

export const ProtectedRoute = ({ adminOnly = false, therapistOnly = false, requireAccess = false }) => {
  const { user, isAdmin, isTherapist, hasAccess } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 space-y-4" data-testid="auth-loading">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  if (therapistOnly && !isTherapist && !isAdmin) return <Navigate to="/" replace />;
  if (requireAccess && !hasAccess) return <Navigate to={lockedPath(user)} replace />;
  return <Outlet />;
};
